import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {Office} from '../../classes/office';
import {Agent} from '../../classes/agent';
import { Angulartics2 } from '../../../../node_modules/angulartics2';
import { AGENT_SEARCH_EMAIL, OFFICE_SEARCH_EMAIL } from '../../classes/analytics-tags';
import { ActivatedRoute } from '../../../../node_modules/@angular/router';
import { SearchPageComponent } from '../search-page/search-page.component';

@Component({
  selector: 'app-card-contact-info',
  templateUrl: './card-contact-info.component.html',
  styleUrls: ['./card-contact-info.component.scss']
})
export class CardContactInfoComponent implements OnInit {
  @Input() contactObject: Agent|Office;
  @Input() callTitle: string;
  @Input() emailTitle: string;
  @Input() isRedesign: boolean = false;
  @Output() onContactObjectClicked: EventEmitter<Agent|Office> = new EventEmitter<Agent|Office>();

  phoneNum: string;
  parsedPhoneNum: string;

  constructor(private angulartics2: Angulartics2, private router: ActivatedRoute) {}

  ngOnInit() {
    this.getPhoneNum();
  }

  stopPropagationForEmail(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  stopPropagationForPhone(event) {
    event.stopPropagation();
  }

  onEmailClicked() {
    if (this.router.snapshot.component === SearchPageComponent) {
      this.angulartics2.eventTrack.next({
        properties: {
          event: this.router.snapshot.params.type === 'office' ? OFFICE_SEARCH_EMAIL : AGENT_SEARCH_EMAIL
        }
      });
    }

    this.onContactObjectClicked.emit(this.contactObject);
  }

  getPhoneNum() {
    if (this.contactObject instanceof Agent) {
      this.phoneNum = this.contactObject.primaryNumberToContact ? this.contactObject.rfc3966FormattedPhoneNumber : '';
      this.parsedPhoneNum = this.contactObject.parsedPhoneNumber;
    } else if (this.contactObject instanceof Office) {
      this.phoneNum = 'tel:' + this.contactObject.telephone;
      this.parsedPhoneNum = this.contactObject.parsedPhoneNumber;
    }
  }
}
